import styled from '@emotion/styled';
import KyruusDrawer from '@kyruus/drawer';

export const Drawer = styled(KyruusDrawer)`
  & .MuiPaper-root: {
    position: absolute,
    // adding a low z-index for customers like baptist with fixed headers
    z-index: 2;
  }
`;

const styledIconOptions = {
  // Filter width attr from being forwarded to the section as prop to prevent validation errors
  shouldForwardProp: (propName) => propName !== 'width'
};

export const Content = styled('section', styledIconOptions)`
  width: ${(props) => props.width || '50vw'};
  overflow-y: hidden;
  ${(props) => (props.minWidth ? `min-width: ${props.minWidth};` : '')}
`;
